<template>
    <div class="privacy-container">
        <h1 class="title">树兰AI健康一体机隐私政策</h1>
        <div class="update-date">最近更新日期：2026年6月12日</div>

        <h2>【特别提示】</h2>
        <div class="tip-box">
            <p>
                请您在使用树兰AI健康一体机及相关服务前，务必仔细阅读、充分理解本隐私政策全部条款，重点关注本政策中以
                <strong>粗体标识</strong>
                的权利义务、信息收集、共享披露、用户权益、免责情形等核心内容。
            </p>
            <p>
                若您不同意本政策任意条款，请立即停止使用本设备及相关服务。您继续使用树兰AI健康一体机、确认授权、提交个人及健康信息的行为，即表示您自愿、知情、同意我们按照本政策约定收集、存储、使用、共享及保护您的个人信息，无任何异议。
            </p>
            <p>
                我们严格依据《中华人民共和国民法典》《中华人民共和国网络安全法》《中华人民共和国个人信息保护法》《信息安全技术个人信息安全规范》（GB/T
                35273-2020）《网络数据安全管理条例》等法律法规及国家标准，合法、合规保护您的个人信息、健康生理数据及诊疗相关数据安全。
            </p>
            <p>
                我们恪守权责一致、目的明确、选择同意、最少必要、确保安全、主体参与、公开透明的核心原则，仅为提供、优化、合规运营本服务处理用户信息，杜绝超范围、超目的、超期限处理用户数据，并严格遵循业界成熟安全标准，落实全方位数据安全保护措施。本政策将完整告知您个人信息处理的全部规则，您可通过本政策清晰知晓自身权利与义务。
            </p>
            <p>本政策将帮助您全面了解以下内容：</p>
            <ol class="no-indent">
                <li>一、定义</li>
                <li>二、我们收集的信息及收集规则</li>
                <li>三、我们如何使用您的个人信息</li>
                <li>四、信息共享、转让、公开披露规则</li>
                <li>五、数据存储与安全保护机制</li>
                <li>六、您的个人信息主体合法权利</li>
                <li>七、未成年人个人信息保护</li>
                <li>八、本政策更新与告知规则</li>
                <li>九、咨询、投诉与联系我们</li>
                <li>十、其他合规约定</li>
            </ol>
        </div>

        <h2>一、定义</h2>
        <ol>
            <li>
                <strong>我们/运营方</strong>
                ：指树兰互联网医院（杭州）有限公司及为树兰AI健康一体机提供研发、部署、运维、诊疗配套服务的全部关联主体，为本服务个人信息处理的唯一责任主体。
            </li>
            <li>
                <strong>树兰AI健康一体机</strong>
                ：指由我们运营，部署于线下药店等合规场所，具备健康指标检测、在线图文/视频问诊、电子处方开具与审核、健康数据记录、个人健康管理、用药指导等功能的智能终端硬件设备及全套配套线上线下服务。
            </li>
            <li>
                <strong>个人信息</strong>
                ：指以电子或者其他方式记录的，能够单独或与其他信息结合识别特定自然人身份，或者反映特定自然人活动情况的各类信息。
            </li>
            <li>
                <strong>个人敏感信息</strong>
                ：指一旦泄露、非法提供或滥用，极易危害人身、财产安全或侵害个人合法权益的信息，包含但不限于身份证件号码、精准健康生理数据、诊疗问诊记录、电子处方信息、用药记录、14周岁以下未成年人全部个人信息。本类信息为重点保护数据，我们仅在获得您明确授权、且服务必需的前提下处理。
            </li>
            <li>
                <strong>合作药店</strong>
                ：指与我们签订合规合作协议、部署本智能一体机、为用户提供线下设备服务、药品销售、处方核验、药品调配配送、售后随访服务的合法零售药店主体。
            </li>
            <li>
                <strong>健康检测数据</strong>
                ：指您使用本一体机检测服务产生的全部生理指标数据，包含身高、体重、血压、血糖、血脂、尿酸、心率、血氧、体温及设备可检测的其他人体生理、体征相关数据。
            </li>
        </ol>

        <h2>二、我们收集的信息及收集规则</h2>
        <p>我们严格遵循合法、正当、必要、最小够用、不超范围原则收集用户信息，仅用于提供、优化本服务、保障服务正常运行及履行法定合规义务，绝不收集与服务无关的用户信息。</p>

        <h3>（一）您主动提供的信息</h3>
        <ol>
            <li>基础身份信息：姓名、性别、年龄、手机号码、身份证件号码；</li>
            <li>问诊与健康信息：您自主填写的病症描述、健康诉求、在线咨询及问诊全过程记录。</li>
        </ol>

        <h3>（二）设备自动采集的信息</h3>
        <ol>
            <li>健康检测数据：身高、体重、血压、血脂、血糖、尿酸、心率、血氧、体温及一体机可检测的全部生理指标数据；</li>
            <li>服务行为记录：问诊发起、视频通话、处方生成、报告查看、数据上传、设备操作、功能使用等全流程服务日志记录。</li>
        </ol>

        <h3>（三）信息合法获取方式</h3>
        <ol>
            <li>您在一体机终端、配套小程序/应用端手动填写、自主选择、主动确认提交的信息；</li>
            <li>一体机合规传感器自动采集的健康检测数据（仅用于本服务，无后台私自采集行为）；</li>
            <li>问诊过程中执业医师、药师根据服务需求记录，且经您本人确认无误的问诊、诊疗信息；</li>
            <li>经您单独、明确授权后，从合法合规渠道获取的必要辅助信息，无授权绝不获取。</li>
        </ol>

        <h3>（四）设备权限调用说明（最小必要）</h3>
        <p>为保障各项功能正常实现，一体机仅调用以下必要权限，所有权限调用均基于服务必需，您可自主知晓并授权，无强制授权、捆绑授权行为：</p>
        <ul class="no-indent">
            <li>· 相机：用于视频问诊、处方及资料扫码、就医凭证拍照上传；</li>
            <li>· 麦克风：用于语音健康咨询、远程视频问诊沟通；</li>
            <li>· 存储：用于本地及云端安全保存您的健康检测报告、问诊记录、处方凭证；</li>
            <li>· 网络：用于服务联网、远程问诊、处方合规流转、数据同步更新；</li>
            <li>· 传感器：用于精准采集血压、体重、心率、体温等健康检测数据。</li>
        </ul>

        <h2>三、我们如何使用您的个人信息</h2>
        <p>我们承诺：所有个人信息、敏感数据仅用于以下明确、合法、必要的服务场景，绝不超目的、超范围使用，绝不用于商业营销、无关推广等用途。</p>
        <ol>
            <li>为您提供健康检测、数据记录、智能分析、健康报告生成、报告查询与留存服务；</li>
            <li>为您发起、提供远程视频问诊、在线健康咨询、专业用药指导、慢病健康管理等医疗配套服务；</li>
            <li>合规生成、核验、流转电子处方，保障处方真实有效，支撑用户合规购药、保障用药安全；</li>
            <li>授权合作药店完成处方核验、药品调配、药品销售与配送、用药售后随访、用药安全提醒、不良反应跟踪服务；</li>
            <li>履行法律法规、监管部门规定的医疗合规、数据留存、安全审计等法定义务；</li>
            <li>优化设备功能、升级服务体验、排查服务故障、保障服务安全稳定运行。</li>
        </ol>

        <h2>四、信息共享、转让、公开披露规则</h2>
        <p>核心原则：非经您明确同意或法定强制要求，我们绝不向任何第三方共享、转让、公开披露您的个人敏感信息。所有第三方合作均签订保密协议，严格约束数据使用范围。</p>

        <h3>（一）合法共享范围及用途</h3>
        <p>您充分知情并同意，我们可在以下最小必要范围内，共享您的相关信息，且共享信息仅限对应服务用途：</p>
        <ol>
            <li>
                合作药店：仅共享您的姓名、手机号、性别、年龄、病症描述、问诊记录、处方信息、用药记录、收货地址、对应健康检测数据，仅限用于：处方核验、药品调配销售、药品配送、用药指导、不良反应跟踪、售后随访服务。
            </li>
            <li>执业医师/执业药师：共享必要的身份信息、健康数据、病症信息，仅限用于开展问诊咨询、处方开具、处方审核、健康评估、用药建议等医疗服务。</li>
            <li>
                第三方技术服务商：仅共享服务必需的非冗余信息，用于设备运维、数据安全存储、音视频通讯、消息推送、系统升级等基础服务，我们已与全部服务商签订严格保密协议，禁止其二次共享、二次使用、泄露用户数据。
            </li>
        </ol>

        <h3>（二）无需您单独授权的法定例外情形</h3>
        <p>以下情形，我们处理、共享相关信息无需征得您的授权同意，且符合法律法规要求：</p>
        <ol>
            <li>为履行法律法规、监管规定的法定义务所必需的；</li>
            <li>与国家安全、国防安全直接相关的；</li>
            <li>与公共安全、公共卫生、重大公共利益直接相关的；</li>
            <li>与犯罪侦查、起诉、审判和判决执行等司法、执法活动直接相关的；</li>
            <li>为维护您或其他自然人的生命、财产等重大合法权益，且无法及时获取本人授权同意的；</li>
            <li>您自行向社会公众公开的个人信息；</li>
            <li>新闻单位开展合法新闻报道所必需的；</li>
            <li>学术研究机构基于公共利益开展统计、学术研究，且最终输出结果已完成去标识化、匿名化处理，无法识别特定个人的；</li>
            <li>法律法规、监管政策明确规定的其他无需授权的情形。</li>
        </ol>

        <h3>（三）通用共享规则</h3>
        <ol>
            <li>明示同意共享：除本政策约定情形外，如需向第三方共享您的信息，我们将单独获取您的明确授权同意，未获同意绝不共享；</li>
            <li>法定强制共享：根据法律法规规定、政府主管部门合法合规的强制性监管、执法要求，我们可依法对外共享相关信息；</li>
            <li>关联主体共享：为保障关联服务协同运行，我们可向合规关联公司共享必要的账户及服务信息，若涉及个人敏感信息共享或变更数据处理目的，将再次单独征求您的授权同意；</li>
            <li>合作伙伴约束：所有授权合作伙伴仅可在服务必需范围内使用共享信息，严禁用于自身经营、营销推广及其他无关用途，我们对合作方数据使用行为全程监督。</li>
        </ol>

        <h3>（四）信息转让规则</h3>
        <p>我们不会擅自转让您的任何个人信息，仅以下两种情形除外：</p>
        <ol>
            <li>经您单独、明确书面或线上确认同意后，方可向指定第三方转让；</li>
            <li>
                若运营方发生合并、收购、破产清算等主体变更情形，涉及数据转让的，我们将要求受让方继续遵守本隐私政策全部约定；若受让方无法合规承接，我们将提前告知并重新获取您的授权，否则不进行数据转让。
            </li>
        </ol>

        <h3>（五）公开披露规则</h3>
        <p>非经您本人明确同意，或无法律法规、司法机关强制要求，我们绝不主动公开披露您的任何个人信息、健康数据及诊疗记录。</p>

        <h2>五、数据存储与安全保护机制</h2>
        <ol>
            <li>存储地点：您的全部个人信息、健康检测数据、诊疗处方数据均仅在中华人民共和国境内存储与处理，绝不跨境传输、跨境存储，法律法规另有规定或您单独书面授权的除外。</li>
            <li>
                存储期限：严格遵循最短必要留存原则，仅在实现本政策约定服务目的、履行法定义务的期限内留存数据；服务终止、留存期限届满后，我们将依法对数据进行彻底删除或不可逆匿名化处理。
            </li>
            <li>
                安全保护措施：我们采用行业标准的加密存储、传输加密、分级访问权限、操作安全审计、数据脱敏、去标识化等全方位技术与管理制度，建立数据分级保护体系，有效防范个人信息被非法访问、泄露、篡改、损毁、滥用等风险。
            </li>
            <li>
                安全事件处置：若发生个人信息泄露、丢失、篡改等数据安全事件，我们将第一时间启动应急处置预案，及时采取补救措施，依法及时向您告知事件情况、处置措施及防护建议，同时严格按照监管要求完成上报工作。
            </li>
        </ol>

        <h2>六、您的个人信息主体合法权利</h2>
        <p>
            您作为个人信息主体，依法享有以下全部合法权利，可通过一体机终端、官方客服、线下服务渠道随时行使，我们将在法定时限内响应处理，且不得因您行使权利拒绝提供基础服务（服务必需数据除外）。
        </p>
        <ol>
            <li>查询权：有权查询我们存储、处理的您的全部个人信息、健康数据及处理记录；</li>
            <li>更正权：发现个人信息、健康数据存在错误、遗漏的，有权要求我们及时更正、补充；</li>
            <li>删除权：在数据处理目的已实现、不再必要、您撤回同意、我们违规处理等情形下，有权要求我们删除个人信息（法律法规强制要求留存的除外）；</li>
            <li>副本获取与限制处理权：有权获取您个人信息、健康数据的合法副本，有权拒绝、限制特定场景下的信息处理行为；</li>
            <li>撤回同意权：您可随时撤回此前的信息处理授权，撤回后我们将终止对应处理行为，不影响此前合法处理的效力；</li>
            <li>投诉申诉权：您对我们的数据处理行为有疑问、异议，或认为自身权益受损的，可随时投诉、申诉，我们将依法核查处理。</li>
        </ol>

        <h2>七、未成年人信息保护</h2>
        <p>未成年人使用本服务必须征得监护人同意，未成年人敏感信息严格重点保护。</p>
        <ol>
            <li>无父母或法定监护人同意的未成年人，不得使用本设备服务、不得提交任何个人信息；</li>
            <li>若您为未成年人，请务必由父母或法定监护人仔细阅读本政策，并在监护人明确同意、陪同使用的前提下使用服务、提交信息；</li>
            <li>我们仅在法律法规允许、监护人明确同意、保护未成年人合法权益的必要范围内，收集、使用、共享未成年人信息，绝不超范围处理；</li>
            <li>依据监管要求，本一体机将设置年龄准入机制，仅对符合法定年龄要求的用户提供对应服务，严控未成年人敏感数据风险。</li>
        </ol>

        <h2>八、本政策更新与告知规则</h2>
        <ol>
            <li>我们可根据法律法规更新、监管政策调整、业务优化、服务升级等情形，适时修订、更新本隐私政策；</li>
            <li>涉及用户核心权益、信息处理规则重大变更的更新，我们将通过一体机弹窗、页面公告、官方通知等显著方式提前告知，保障您的知情权；</li>
            <li>政策更新后，您继续使用本服务的行为，即视为您认可并同意更新后的全部政策条款。</li>
        </ol>

        <h2>九、咨询、投诉与联系我们</h2>
        <p>您对本政策有任何疑问、建议、投诉，或发现个人信息疑似泄露、违规处理的，可通过以下渠道联系我们，我们将在15个工作日内完成核查并回复。</p>
        <ul class="no-indent contact">
            <li>1. 联系电话：0571-86022725</li>
            <li>2. 书面邮寄地址：杭州市余杭区良渚街道通运号楼5楼 树兰AI健康一体机个人信息保护小组（收）</li>
            <li>3. 维权途径：若您对我们的处理结果不满意，或认为我们的信息处理行为侵害您的合法权益，可依法向有管辖权的人民法院提起诉讼，或向监管部门投诉维权。</li>
        </ul>

        <h2>十、其他合规约定</h2>
        <ol>
            <li>本政策未尽事宜，均按照国家现行法律法规、行业标准执行；</li>
            <li>本政策条款若与法律法规冲突，以现行法律法规为准，其余条款继续有效；</li>
            <li>本政策为用户与我们之间关于个人信息保护的有效合规约定，双方均需严格遵守。</li>
        </ol>
    </div>
</template>

<script>
export default {
    name: 'PrivacyPolicy'
};
</script>

<style scoped>
.privacy-container {
    max-width: 900px;
    margin: 30px auto;
    padding: 0 20px;
    color: #333;
    font-family: 'Microsoft Yahei', SimSun, sans-serif;
    font-size: 26px;
    line-height: 1.8;
}

.title {
    text-align: center;
    font-size: 32px;
    margin-bottom: 20px;
    font-weight: bold;
}

.update-date {
    text-align: center;
    margin-bottom: 25px;
    color: #555;
}

.tip-box {
    /* border: 1px solid #ccc; */
    padding: 15px;
    margin: 20px 0;
    /* border-radius: 4px; */
    /* background-color: #f9f9f9; */
}

h2 {
    font-size: 32px;
    margin: 25px 0 10px;
    font-weight: bold;
}

h3 {
    font-size: 32px;
    margin: 18px 0 8px;
    font-weight: bold;
}

p {
    margin: 8px 0;
    text-indent: 2em;
}

.no-indent {
    text-indent: 0 !important;
}

ul,
ol {
    margin: 8px 0 8px 2em;
}

li {
    margin: 6px 0;
}

strong {
    font-weight: bold;
}

.contact {
    margin: 10px 0;
}
</style>
